module.exports = __webpack_public_path__ + "static/media/game-Rdoor.72142929.png";